if (!customElements.get('our-expertise')) {
  customElements.define(
    'our-expertise',
    class OurExpertise extends HTMLElement {
      constructor() {
        super();
        this.categories = null;
        this.images = null;
        this.currentActive = null;
        this.boundHandlers = new Map();
        this.rotateTimerId = null;
      }

      connectedCallback() {
        this.categories = this.querySelectorAll('.expertise-category');
        this.images = this.querySelectorAll('.expertise-image');
        
        if (this.categories.length === 0 || this.images.length === 0) {
          return;
        }

        this.currentActive = this.categories[0].dataset.industry;
        this.autoRotate = this.dataset.autoRotate === 'true';
        this.rotateIntervalSec = Math.max(2, parseInt(this.dataset.rotateInterval, 10) || 5);

        this.categories.forEach((category) => {
          const hoverHandler = (e) => this.handleCategoryHover(e);
          const clickHandler = (e) => this.handleCategoryClick(e);
          this.boundHandlers.set(category, { hoverHandler, clickHandler });
          category.addEventListener('mouseenter', hoverHandler);
          category.addEventListener('click', clickHandler);
        });

        if (this.autoRotate && this.categories.length > 1) {
          this.startAutoRotate();
        }
      }

      startAutoRotate() {
        const intervalSec = this.rotateIntervalSec ?? 5;
        this.stopAutoRotate();
        this.rotateTimerId = setInterval(() => {
          this.advanceToNext();
        }, intervalSec * 1000);
      }

      stopAutoRotate() {
        if (this.rotateTimerId) {
          clearInterval(this.rotateTimerId);
          this.rotateTimerId = null;
        }
      }

      advanceToNext() {
        if (!this.categories?.length) return;
        const currentIndex = Array.from(this.categories).findIndex(
          (c) => c.dataset.industry === this.currentActive
        );
        const nextIndex = (currentIndex + 1) % this.categories.length;
        const nextId = this.categories[nextIndex].dataset.industry;
        this.switchIndustry(nextId);
      }

      disconnectedCallback() {
        this.stopAutoRotate();
        if (this.categories) {
          this.categories.forEach((category) => {
            const handlers = this.boundHandlers.get(category);
            if (handlers) {
              category.removeEventListener('mouseenter', handlers.hoverHandler);
              category.removeEventListener('click', handlers.clickHandler);
            }
          });
          this.boundHandlers.clear();
        }
      }

      handleCategoryHover(event) {
        const industryId = event.currentTarget.dataset.industry;
        this.switchIndustry(industryId);
      }

      handleCategoryClick(event) {
        const industryId = event.currentTarget.dataset.industry;
        this.switchIndustry(industryId);
      }

      switchIndustry(industryId) {
        if (industryId === this.currentActive) {
          return;
        }

        this.currentActive = industryId;

        this.categories.forEach((category) => {
          if (category.dataset.industry === industryId) {
            category.classList.add('active');
          } else {
            category.classList.remove('active');
          }
        });

        this.images.forEach((image) => {
          if (image.dataset.industry === industryId) {
            image.classList.add('active');
          } else {
            image.classList.remove('active');
          }
        });

        if (this.autoRotate && this.categories?.length > 1) {
          this.startAutoRotate();
        }
      }
    }
  );
}
